
  document.addEventListener('DOMContentLoaded', function () {
    console.log("123")
    const form = document.querySelector('#visibleCheckout');
    const checkbox = document.getElementById('accept_tos');
    const errorText = document.getElementById('tos-error');
    console.log(form);
    console.log(checkbox);
    console.log(errorText);
    if (form && checkbox && errorText) {
      form.addEventListener('click', function (e) {
        if (!checkbox.checked) {
          e.preventDefault();
          errorText.style.display = 'block';
        } else {
          errorText.style.display = 'none';
          document.querySelector("#checkout.cart__checkout-button").click();
        }
      });

      checkbox.addEventListener('change', function () {
        if (checkbox.checked) {
          errorText.style.display = 'none';
          
        }
      });
    }
  });
